import Vue from 'vue'
import './public-path'
import App from './App.vue' // 根组件
import VueRouter from 'vue-router'
import routes from './router'
import store from './store'
import './utils/antd'
import 'ant-design-vue/dist/antd.css'
import './css/index.scss'
import actions from './qiankun/actions'
import i18n from './utils/lang'
// 注册全局过滤器
import * as filters from './common/filters' // global filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

const env = 'dev'

Vue.config.devtools = env === 'dev' ? true : false
Vue.config.silent = env === 'dev' ? false : true

Vue.prototype.$bus = new Vue()

//路由跳转后，页面回到顶部
// router.afterEach(() => {
//   document.body.scrollTop = 0;
//   document.documentElement.scrollTop = 0;
// });

let router = null
let instance = null
function render(props = {}) {
  const { container, priv, addPane } = props
  if (props) {
    // 注入 actions 实例
    actions.setActions(props)
    if (addPane) {
      Vue.prototype.$addPane = addPane
    } else {
      Vue.prototype.$addPane = ({ route }) => {
        // router.push(route.replace('/aftersale_web', ''))
        //打开新页面
        window.open(route, '_blank')
      }
    }
  }
  router = new VueRouter({
    base: window.__POWERED_BY_QIANKUN_PARENT__
      ? `/${window.__QIANKUN_PARENTNAME__}/purchase`
      : window.__POWERED_BY_QIANKUN__
      ? '/purchase'
      : '/',
    mode: 'history',
    routes,
  })
  router.beforeEach((to, from, next) => {
    // console.log('to, from', to, from)
    if (to.name === 'addPurchase' && from.name === 'purchaseDetail') {
      // 清空 addPurchase 组件的数据
      to.meta.clearData = true
    }
    next()
  })
  router.afterEach((to, from) => {
    if (from.name == 'purchaseDetail') {
      routes.forEach((item) => {
        if (item.name == 'addPurchase') {
          item.meta.keepAlive = false
        }
      })
    }
    if (from.name == 'transferDetail') {
      routes.forEach((item) => {
        if (item.name == 'addTransfer') {
          item.meta.keepAlive = false
        }
      })
    }
    if (from.name == 'addTransfer') {
      from.meta.keepAlive = true
    }
  })
  Vue.use(VueRouter)
  instance = new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
  }).$mount(container ? container.querySelector('#app') : '#app')

  Vue.prototype.priv = function (name) {
    return priv(name)
  }
}

// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
  render()
}

export async function bootstrap() {
  console.log('[vue2] scm app bootstraped')
}

export async function mount(props) {
  render(props)
}

export async function unmount() {
  instance.$destroy()
  instance.$el.innerHTML = ''
  instance = null
  router = null
}
